import { getStrapiAssetUrl } from '@lib/strapi';
import { useMemo } from 'react';

import { SanitizedStoryPage } from '../types';

export const useStrapiVideo = (storyPage: SanitizedStoryPage) => {
    const poster = useMemo(
        () => getStrapiAssetUrl(storyPage.media.formats.thumbnail),
        [storyPage]
    );

    const hdMp4Src = useMemo(
        () => getStrapiAssetUrl(storyPage.media.formats?.['hd_mp4']),
        [storyPage]
    );

    const fallbackSrc = useMemo(
        () =>
            `${process.env.NEXT_PUBLIC_AWS_CF_URL}/${storyPage.media.hash}${storyPage.media.ext}`,
        [storyPage.media.hash, storyPage.media.ext]
    );

    return {
        poster,
        src: [
            {
                type: 'video/mp4',
                src: hdMp4Src,
            },
            {
                type: 'video/mp4',
                src: fallbackSrc,
            },
        ],
    };
};
